/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import React from 'react'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { BaseModal } from 'components/Modals/BaseModal'
import { ReactComponent as CreatedIcon } from './icons/created.svg'
import * as classes from './styles'

export type ItemCreatedModalProps = {
  open: boolean
  title: string
  subtitle: string | React.ReactElement
  firstOptionText: string
  secondOptionText: string
  onFirstOptionClick: () => void
  onSecondOptionClick: () => void
  onClose: () => void
}

export const ItemCreatedModal = ({
  open,
  title,
  subtitle,
  firstOptionText,
  secondOptionText,
  onFirstOptionClick,
  onSecondOptionClick,
  onClose,
  ...props
}: ItemCreatedModalProps) => (
  <BaseModal open={open} onClose={onClose} {...props}>
    <CreatedIcon />
    <Typography css={classes.title} variant="title2">
      {title}
    </Typography>
    <Typography css={classes.subtitle} variant="body2">
      {subtitle}
    </Typography>
    <Button variant="contained" color="blue" fullWidth size="large" onClick={onFirstOptionClick}>
      {firstOptionText}
    </Button>
    <Button variant="outlined" color="blue" fullWidth size="large" onClick={onSecondOptionClick}>
      {secondOptionText}
      <AddRoundedIcon css={classes.iconPlus} />
    </Button>
  </BaseModal>
)
